/**
 * MGT application card view preference in localStorage.
 * Value: "big" keeps the featured card layout, "compact" keeps small-icon layout.
 */
const MGT_VIEW_MODE_KEY = "iwork-mgt-view-mode";
const BIG_MODE = "big";
const COMPACT_MODE = "compact";
export function getMgtViewIsBig() {
  try {
    return localStorage.getItem(MGT_VIEW_MODE_KEY) !== COMPACT_MODE;
  } catch (e) {
    return true;
  }
}
export function setMgtViewIsBig(isBig) {
  try {
    localStorage.setItem(MGT_VIEW_MODE_KEY, isBig ? BIG_MODE : COMPACT_MODE);
  } catch (e) {
    // 浏览器禁用 localStorage 时仅影响偏好持久化，不阻断本次视图切换。
  }
  return isBig;
}